import { render, staticRenderFns } from "./ContentOverlay.vue?vue&type=template&id=4c3669e3&"
import script from "./ContentOverlay.vue?vue&type=script&lang=js&"
export * from "./ContentOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c3669e3')) {
      api.createRecord('4c3669e3', component.options)
    } else {
      api.reload('4c3669e3', component.options)
    }
    module.hot.accept("./ContentOverlay.vue?vue&type=template&id=4c3669e3&", function () {
      api.rerender('4c3669e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/ContentOverlay.vue"
export default component.exports